import { render, staticRenderFns } from "./class_student.vue?vue&type=template&id=1d019730&scoped=true"
import script from "./class_student.vue?vue&type=script&lang=js"
export * from "./class_student.vue?vue&type=script&lang=js"
import style0 from "./class_student.vue?vue&type=style&index=0&id=1d019730&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d019730",
  null
  
)

export default component.exports